import React from "react"
import Text from "@amzn/meridian/text";
import {FormattedMessage} from "react-intl";
import Column from "@amzn/meridian/column";
import Link from "@amzn/meridian/link";

const ActionableMetricView = (data) => {

    const onMetricCountClick = () => {
        if (data.onMetricCountClick) {
            data.onMetricCountClick();
        }
    }
 
    return (
        <Column spacing="small">
            {data.dwellStatus.title ? 
                <Text >
                    <FormattedMessage id={data.dwellStatus.title} defaultMessage={data.dwellStatus.message}/>
                </Text> 
                : null
            }
            <Text type="d50">
                {data.onMetricCountClick ? 
                <Link type={"secondary"} onClick={onMetricCountClick}>{data.dwellStatus.value}</Link> :
                data.dwellStatus.value
                }
            </Text>
        </Column>
    )
}

export default ActionableMetricView


// WEBPACK FOOTER //
// ./src/components/dwellRush/ActionableMetricView.js